import { render } from "./Waybill.vue?vue&type=template&id=d532e9ae&scoped=true&ts=true"
import script from "./Waybill.vue?vue&type=script&lang=ts"
export * from "./Waybill.vue?vue&type=script&lang=ts"

import "./Waybill.vue?vue&type=style&index=0&id=d532e9ae&scoped=true&lang=scss"

import exportComponent from "/Users/wangkaining/Code/vue_code/newapps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d532e9ae"]])

export default __exports__